<template>
  <div>
    <top-title
      name="店铺装修"
      style="margin: 20px 20px; min-width: 980px"
    ></top-title>

    <div class="integralEden">
      <div class="content">
        <div class="hint">
          <img
            src="@/assets/images/new_icon_waring_yellow.png"
            style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 16px 4px 0 3px;
          "
          />
          页面装修可为店铺会员中心提供个性化页面展示，商家可灵活调整店铺会员中心页面布局和展示内容，提高页面灵活性及扩展性，提高会员感知度，增强会员黏性。
        </div>
        <div class="link">
          <div class="left">
            <div class="top">
              <span>首页链接：</span>
              <div class="input">
                <el-input
                  v-model="input"
                  placeholder="请输入内容"
                  id="foo"
                ></el-input>
                <div class="aaa">
                  注：可将链接装修到店铺首页,宝贝详情页或者各类活动页等处
                </div>
              </div>
              <div
                class="copy"
                @click="copyLink"
                data-clipboard-target="#foo"
                ref="copy"
              >
                复制链接
              </div>
            </div>
            <div class="down">
              <div class="release">
                <div class="item">
                  <i class="el-icon-remove-outline" v-show="true"></i>
                  <!-- <i class="el-icon-circle-check"></i> -->
                  会员中心发布
                </div>
                <div>
                  <div class="preview">
                    预览
                    <img v-if="value" src="@/assets/images/preview1.svg" alt="">
                    <img v-else src="@/assets/images/preview2.svg" alt="">
                  </div>
                  <el-switch
                    v-model="value"
                    active-color="#49C568"
                    inactive-color="#b1b6bd"
                    @change="change(value)"
                  >
                  </el-switch>
                </div>
              </div>
              <!-- <div class="pattern">
                <div class="item">
                  <i class="el-icon-remove-outline"></i>
                  <i class="el-icon-circle-check" v-show="false"></i>
                  开卡模式未开启
                </div>
                <div>
                  <div class="preview ccc">预览 ></div>
                  <div class="model">设置开卡模式</div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="right" v-if="value">
            <div class="title">扫码预览手机端效果</div>
            <div id="qrcode" ref="qrCode"></div>
          </div>
        </div>
        <div class="compile">
          <div class="aaa"></div>
          编辑模板
        </div>
        <div class="template">
          <div class="default">
            <div
              v-for="(item, index) in TemplateList"
              :key="index"
              style="margin-bottom: 10px"
              class="default_item"
            >
              <div class="item">
                <div class="gray">
                  <div class="red" 
                  v-zoom='{from:"忠诚度管理-店铺装修",name:"使用模板"}'
                  @click="useTemplate(item.id)">
                    使用此模板
                  </div>
                  <div class="compiles">
                    <span 
                    v-zoom='{from:"忠诚度管理-店铺装修",name:"编辑模板"}'
                    @click="gotoTemplatess(item.id)">编辑</span>
                    |
                    <span v-zoom='{from:"忠诚度管理-店铺装修",name:"删除模板"}' @click="deleteTemplatess(item.id)">删除</span>
                  </div>
                </div>
              </div>
              <div class="selected" v-if="item.status == 2">
                <div class="selName">已选</div>
              </div>
              <div class="name" v-if="item.name">{{ item.name }}</div>
              <div class="name" v-else>模板</div>
            </div>
            <div class="new" v-zoom='{from:"忠诚度管理-店铺装修",name:"新建模板"}' @click="$router.push('/draw')">
              <div style="margin-bottom: 10px">
                <div class="new_item">
                  <i class="el-icon-plus"></i>
                  <div style="color: #9a9a9a">点此添加新的会员中心方案</div>
                </div>
                <div class="name">新建模板</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import {
  fitmentTemplateList,
  DELETETemplateList,
  useFitmentTemplate,
} from "@/api/serviceCenter/DecorationInfoController.js";
import topTitle from "../../components/top-title";
import {
  updateMemberCenterURL,
  closeMemberCenterURL,
  getMemberCenterURLStatus,
} from "@/api/memberCenter";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
export default {
  components: {
    topTitle,
  },
  data() {
    return {
      input: "https://yphy-isv.isvjcloud.com/point-h5",
      value: false,
      TemplateList: [],
      copyBtn: null,
      isShow: true,
      venderId: "",
    };
  },
  mounted() {
    this.login();
    this.isPointsEnableds();
    this.change();
    this.getfitmentTemplateList();
    this.copyBtn = new this.clipboard(this.$refs.copy);
  },
  watch: {},
  methods: {
    change(value) {
      if (value == true) {
        let url = {
          url: this.input,
        };
        updateMemberCenterURL(url).then((res) => {
          this.$nextTick(() => {
            let qrcode = new QRCode(this.$refs.qrCode, {
              width: 140, // 二维码宽度，单位像素
              height: 140, // 二维码高度，单位像素
              text: this.input, // 生成二维码的链接
            });
          });
        });
      }
      if (value == false) {
        document.getElementById("qrcode").innerHTML = ""; //清空二维码
        closeMemberCenterURL().then((res) => {
          console.log(res, 222);
        });
      }
    },
    // 拼接路径
    login() {
      let tiem = Math.round(new Date() / 1000);
      prefixurl().then((res) => {
        this.venderId = res.data.venderId;
        this.input = `https://yphy-isv.isvjcloud.com/point-h5?venderId=${res.data.venderId}&time=${tiem}`;
      });
    },
    //  是否开启积分
    isPointsEnableds() {
      getMemberCenterURLStatus().then((res) => {
        console.log('point',res.data);
        this.value = res.data;
        if (res.data == true) {
          this.$nextTick(() => {
            let qrcode = new QRCode(this.$refs.qrCode, {
              width: 140, // 二维码宽度，单位像素
              height: 140, // 二维码高度，单位像素
              text: this.input, // 生成二维码的链接
            });
          });
        }
      });
    },
    // 编辑模板
    gotoTemplatess(id) {
      this.$router.push({
        path: "/draw",
        query: {
          id,
        },
      });
    },
    // 获取模板列表
    getfitmentTemplateList() {
      let form = {
        current: 1,
        size: 10,
      };
      fitmentTemplateList(form).then((res) => {
        console.log(res, 8887);
        this.TemplateList = res.data.records;
        if (res.data.records.length >= 5) {
          this.isShow = false;
        }
      });
    },
    // 删除模板
    deleteTemplatess(id) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          DELETETemplateList(id).then((res) => {
            this.getfitmentTemplateList();
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 设置使用当前模板
    useTemplate(id) {
      useFitmentTemplate(id).then((res) => {
        this.$message({
          message: "设置成功",
          type: "success",
        });
        this.getfitmentTemplateList();
      });
    },
    // 复制链接
    copyLink() {
      let _this = this;
      let clipboard = _this.copyBtn;
      clipboard.on("success", function(e) {
        e.clearSelection();
        _this.$message({
          message: "复制成功！",
          type: "success",
        });
      });
      clipboard.on("error", function(e) {
        _this.$message({
          message: "复制失败！，请刷新重试",
          type: "error",
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  margin-bottom: 50px;
  .content {
    box-sizing: border-box;
    min-height: 220px;
    padding: 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .hint {
      // height: 45px;
      line-height: 45px;
      width: 100%;
      box-sizing: border-box;
      padding: 0 0 0 15px;
      background-color: #fffaee;
    }
    .link {
      display: flex;
      margin-top: 20px;
      .right {
        margin-left: 40px;
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        flex-direction: column;
        align-items: center;
        padding: 10px 0 0 0;
        width: 166px;
        height: 200px;
        background-color: #f9f9f9;
        font-size: 14px;
        font-weight: 400;
        .title {
          margin-bottom: 15px;
        }
      }
      .left {
        height: 200px;
        .top {
          display: flex;
          align-items: center;
          /deep/ .el-input--small {
            width: 650px;
            height: 32px;
          }
          .copy {
            width: 98px;
            height: 32px;
            display: flex;
            cursor: pointer;
            justify-content: center;
            align-items: center;
            background: #fe4d45;
            border-radius: 3px;
            font-size: 14px;
            color: #ffffff;
            margin-left: 20px;
          }
          .input {
            position: relative;
          }
          .aaa {
            position: absolute;
            bottom: -30px;
            left: 0px;
            color: #999999;
          }
        }
        .down {
          display: flex;
          .el-icon-remove-outline {
            font-size: 32px;
            color: #cccccc;
            margin-right: 10px;
          }
          .el-icon-circle-check {
            font-size: 32px;
            color: #fe8f8a;
            margin-right: 10px;
          }
          .item {
            display: flex;
            align-items: center;
          }
          .preview {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            color: #7f85e9;
            margin-bottom: 25px;
            margin-left: 10px;
            position: relative;
            img{
              position: absolute;
              z-index: 9999;
              left: -23px;
              top: 5px;
              display: none;
            }
            &:hover{
              img{
                display: block;
              }
            }
          }
          .ccc {
            margin-left: 60px;
          }
          .release {
            width: 460px;
            height: 107px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 20px;
            background: #ffffff;
            border: 1px solid #fec1be;
            border-radius: 3px;
            margin-top: 60px;
          }
          .pattern {
            display: flex;
            box-sizing: border-box;
            justify-content: space-between;
            padding: 0 20px;
            align-items: center;
            margin-left: 20px;
            width: 460px;
            font-size: 16px;
            color: #333333;
            height: 107px;
            background: #fafafa;
            border-radius: 3px;
            margin-top: 60px;
            .model {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 108px;
              height: 32px;
              background: #ffffff;
              border: 1px solid #fe4d45;
              opacity: 1;
              border-radius: 3px;
              font-size: 14px;
              color: #fe4d45;
            }
          }
        }
      }
    }
    .compile {
      margin-top: 30px;
      width: 100%;
      height: 32px;
      background: #fafafa;
      opacity: 1;
      display: flex;
      align-items: center;
      margin-left: 10px;
      font-size: 14px;
      color: #333333;
      .aaa {
        width: 2px;
        margin-right: 5px;
        height: 14px;
        background: #fe4d45;
        opacity: 1;
        border-radius: 3px;
      }
    }
    .name {
      width: 100%;
      text-align: center;
    }
    .template {
      display: flex;
      margin-top: 20px;
      .el-icon-plus {
        font-size: 32px;
        color: #9a9a9a;
      }

      .default {
        flex-wrap: wrap;
        display: flex;
        align-items: center;
        margin-right: 30px;

        .item {
          margin-right: 20px;
          margin-bottom: 10px;
          width: 228px;
          height: 390px;
          background: #f9f9f9;
          background-image: url("../../assets/images/bg.jpg");
          background-size: 100%;
          .gray {
            display: none;
            .red {
              margin-top: 200px;
              width: 150px;
              height: 32px;
              background-color: #ff3333;
              color: #ffffff;
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 3px;
            }
            .compiles {
              width: 150px;
              height: 32px;
              margin-top: 10px;
              display: flex;
              cursor: pointer;
              border-radius: 3px;
              align-items: center;
              justify-content: space-around;

              background: #fafafa;
              span {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50%;
                height: 100%;
              }
            }
          }
          &:hover {
            .gray {
              display: block;
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              flex-direction: column;
              justify-content: center;
              background-color: rgba(0, 0, 0, 0.5);
            }
          }
        }
        .default_item {
          position: relative;
          .selected {
            position: absolute;
            top: -6px;
            left: -26px;
            width: 0;
            height: 0;
            border-left: 40px solid transparent;
            border-right: 40px solid transparent;
            border-bottom: 40px solid red;
            transform: rotate(-45deg);
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .selName {
              width: 40px;
              height: 40px;
              position: absolute;
              top: 20px;
              right: -25px;
              color: #ffffff;
            }
          }
        }
      }
      .new {
        .new_item {
          margin-right: 20px;
          margin-bottom: 10px;
          width: 228px;
          height: 390px;
          border: 1px solid #eee;
          background: #fff;
          background-size: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
      }
    }
  }
}
</style>
